import UrlUtils from "../../utils/url.es6";
import ApiClient from "../../modules/api.es6";

export default class NewsDetail {
    constructor() {
        this.current = -1;
        this.query = {};
        this.items = [];

        this._init();
    }

    _init() {
        this.query = UrlUtils.getQuery();

        if(!this.query.id){
            return;
        }

        // acms_loaderが読み込まれるまで待機
        if(typeof window.acms_loader !== 'undefined'){
            this._loadJson();
        }
        else{
            // 読み込み待機
            setTimeout(() => this._init(), 100);
        }
    }

    async _loadJson() {

        // acms_loaderのコールバックを設定
        window.acms_loader.ready = (json) => {
            this._parseJson(json);
            this._createHeaderHTML();
            this._createBodyHTML();
            this._updatePager();
        };

        // API呼び出し開始
        window.acms_loader.start();
    }

    _parseJson(json) {
        if (!json || !Array.isArray(json)) {
            console.error("_parseJson: jsonが配列ではありません", json);
            return;
        }

        for (let i = 0; i < json.length; i++) {
            const data = {};
            data.id = json[i].id;
            data.title = json[i].title_html;
            data.date = this._formatDate(json[i].date);
            data.isNew = parseInt(json[i].newflg);
            data.content = json[i].content_html;

            const tagRegex = /#tag:([a-zA-Z0-9,]+)/;
            const match = data.content.match(tagRegex);
            if (match) {
                data.tag = match[1].trim(); // タグを抽出
                data.content = data.content.replace(tagRegex, ""); // タグを本文から削除
            } else {
                data.tag = null;
            }

            this.items.push(data);

            if (data.id === this.query.id) {
                this.current = parseInt(i);
            }
        }
    }

    _formatDate(dateStr) {
        const options = {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
        };

        const formatter = new Intl.DateTimeFormat("en-US", options);
        const date = new Date(dateStr);
        const parts = formatter.formatToParts(date);

        const year = parts.find((p) => p.type === "year").value;
        const month = parts.find((p) => p.type === "month").value;
        const day = parts.find((p) => p.type === "day").value;

        return `20${year}.${month}.${day}`;
    }

    _createHeaderHTML() {
        const data = this.items[this.current];
        const devStr = this.query.dev === "1" ? "&dev=1" : "";

        let header = `
            <p class="newsdet__header__date">${data.date}</p>
            <h1 class="newsdet__header__title">${data.title}</h1>`;

        document.querySelector(".js-newsdetail__header").innerHTML = header;
    }

    _createBodyHTML() {
        const content = this.items[this.current].content;
        document.querySelector(".js-newsdetail__body").innerHTML = content;
    }

    _updatePager() {
        const prevLinks = document.querySelectorAll(".js-pager__prev");
        const nextLinks = document.querySelectorAll(".js-pager__next");
        const indexLink = document.querySelector(".js-pager__index");
        const devStr = this.query.dev === "1" ? "&dev=1" : "";

        // prev
        if (this.current > 0) {
            const href = `./detail.php?id=${this.items[this.current - 1].id + devStr}`;
            prevLinks.forEach((el) => {
                el.href = href;
                el.removeAttribute("aria-disabled");
            });
        } else {
            prevLinks.forEach((el) => {
                el.href = "#";
                el.setAttribute("aria-disabled", "true");
            });
        }

        // next
        if (this.current < this.items.length - 1) {
            const href = `./detail.php?id=${this.items[this.current + 1].id + devStr}`;
            nextLinks.forEach((el) => {
                el.href = href;
                el.removeAttribute("aria-disabled");
            });
        } else {
            nextLinks.forEach((el) => {
                el.href = "#";
                el.setAttribute("aria-disabled", "true");
            });
        }

        if (this.query.dev === "1" && indexLink) {
            indexLink.href = "./?dev=1";
        }
    }
}
